import { render } from "./TangkiDaftar.vue?vue&type=template&id=4caa887d"
import script from "./TangkiDaftar.vue?vue&type=script&lang=js"
export * from "./TangkiDaftar.vue?vue&type=script&lang=js"

import "./TangkiDaftar.vue?vue&type=style&index=0&id=4caa887d&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__